import Cookies from 'js-cookie';
import toast from "react-hot-toast";
import { axiosInstance } from "../lib/axios";

export const postProject = async (form) => {
    try {
        const {
            title, marketType, image, description, id, isFeatured, order
        } = form;

        const formData = new FormData();
        // Required Field
        if (id)
            formData.append("id", id);
        formData.append("title", title);
        formData.append("order", order);
        formData.append("marketType", marketType);
        formData.append("description", description);
        formData.append("isFeatured", isFeatured);

        if (image) {
            if (typeof image === "string") {
                formData.append("image", image);
            }
            else {
                formData.append("pictures", image);
            }
        }

        const accessToken = Cookies.get("accessToken");

        const res = await axiosInstance.post(
            `/project/register`,
            formData,
            {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                    "Content-Type": "multipart/form-data",
                },
            }
        );

        toast.success("Successfully Registered!");
        return res.data?.data;

    } catch (err) {
        console.error(err);
        toast.error(err.response?.data?.message || "Something went wrong!");
    }
};

export const getProject = async (pageNumber, pageSize, search, field) => {
    try {

        const params = new URLSearchParams();
        params.append('field', field);
        params.append('search', search);
        params.append('pageSize', pageSize);
        params.append('pageNumber', pageNumber);

        const res = await axiosInstance.get(`/project/all?${params.toString()}`)
        // toast.success("Successfully fetched!");
        return res.data.data
    } catch (err) {
        console.log(err.response?.data?.message)
        toast.error(err.response?.data?.message || "Something went wrong!");
    }
}

export const getProjectByID = async (id) => {

    try {
        const res = await axiosInstance.get(`/project/${id}`)
        return res.data.data

    } catch (err) {
        console.log(err.response?.data?.message)
        toast.error(err.response?.data?.message || "Something went wrong!");
    }
}

export const deleteProject = async (id) => {
    try {
        if (!id) {
            toast.error("id is not present");
        }
        const accessToken = Cookies.get("accessToken");
        const res = await axiosInstance.delete(`/project/${id}`, {
            headers: {
                Authorization: `Bearer ${accessToken}`,
            },
        })
        toast.success("Successfully deleted!");
        return res
    } catch (err) {
        console.log(err.response?.data?.message)
        toast.error(err.response?.data?.message || "Something went wrong!");
    }
}

export const postProjectdata = async (form) => {
    try {

        const accessToken = Cookies.get("accessToken");
        const res = await axiosInstance.post(`/home/project`, form, {
            headers: {
                Authorization: `Bearer ${accessToken}`,
            },
        })
        toast.success("Successfully resgistered!");
        return res
    } catch (err) {
        console.log(err.response?.data?.message)
        toast.error(err.response?.data?.message || "Something went wrong!");
    }
}

export const orderProjects = async (order) => {
    try {

        const accessToken = Cookies.get("accessToken");
        const res = await axiosInstance.post(`/project/order`, { order: order }, {
            headers: {
                Authorization: `Bearer ${accessToken}`,
            },
        })
        toast.success("Successfully Ordered!");
        return res
    } catch (err) {
        console.log(err.response?.data?.message)
        toast.error(err.response?.data?.message || "Something went wrong!");
    }
}

export const getTotalProject = async () => {
    try {
        const res = await axiosInstance.get(`/project/total`)
        // toast.success("Successfully fetched!");
        return res.data.data
    } catch (err) {
        console.log(err.response?.data?.message)
        toast.error(err.response?.data?.message || "Something went wrong!");
    }
}